export default {
  type: "string",
  enum: [
    "exhibition",
  ],
  default: "exhibition"
}